import { useHistory } from "react-router-dom";
import { displayToast } from "../../../components/app/AppToast";
import { useCurrentUser } from "./useCurrentUser";
import { useTranslation } from "react-i18next";

/**
 * Lightweight guard for the rare case where a user exists but hasn't finished onboarding.
 * Returns a function: (errorMessage?) => boolean. Returns true if onboarded, false + toast + redirect if not.
 */
export function useOnboardingGuard() {
  const history = useHistory();
  const { t } = useTranslation();
  const { isOnboarded } = useCurrentUser();

  return (errorMessage?: string): boolean => {
    if (!isOnboarded) {
      displayToast(
        errorMessage ??
          t("🔒 Please complete your profile first to access this page."),
        "warning"
      );
      history.replace("/signup/onboarding");
      return false;
    }

    return true;
  };
}
